import { Component, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { SharedTabDataService } from '../shared-tab-data-service.component';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { EcatService } from 'src/app/services/ecat.service';
import { encryptParam } from 'src/app/utils/encrypt'
import { NzModalService } from 'ng-zorro-antd/modal';
import { VideoModalComponent } from 'src/app/pages/official-website/ecat/video/video-modal.component';
import { RemarkMap, EcatUtils } from 'src/app/utils/ecat-util';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

@Component({
    selector: 'app-vin-parts-search',
    templateUrl: './vin-parts-search.component.html',
    styleUrls: ['./vin-parts-search.component.less']
})
export class VinPartsSearchComponent {
    constructor(private message: NzMessageService, private sharedData: SharedTabDataService,
        private ecatalogService: EcatalogService, private ecatService: EcatService, private modal: NzModalService,
        private sharedDataService: SharedDataService, private router: Router) {
        this.sharedDataService.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }
    @Output() dataEvent = new EventEmitter<string>();
    @Input() activeTabIndex: number = 0;
    @Input() productList: string[] = [];
    @Output() viewDetail = new EventEmitter<number>();
    @Output() clearPartNoToFilter = new EventEmitter<any>();

    RemarkMap: any = RemarkMap;
    Math = Math;
    parseFloat = parseFloat;
    selectedVehicles: string[] = [];
    filterMenu: any[] = [];
    categoryListForCar: any[] = [];
    carIds: string = '';
    carIdsForParts: string = '';
    selectedCarInfo: any = {};
    showVehicleList = false;
    widthConfig = ['80px', '100px', '160px', '100px', '160px', '80px', '100px', '100px']
    partList: any[] = [];
    pageIndex = 1;
    pageSize = 10;
    selectedProductList: string[] = [];
    isAllChecked = false;
    subscription: any;
    pageInfo: any = {};
    partNoToFilter: any = '';
    selectedCategory1Name: Set<string> = new Set();
    isGroupLoading = false;
    isTableLoading = false;
    selectedLevelIds = '';
    isDealerPortal: boolean = false;

    sortTypeFormularFn = (a: any, b: any) => a.typeFormular.localeCompare(b.typeFormular);
    sortPartNoFn = (a: any, b: any) => a.partNo.localeCompare(b.partNo);
    sortPartNoStatusFn = (a: any, b: any) => a.partNoStatus.localeCompare(b.partNoStatus);
    sortPartNameFn = (a: any, b: any) => a.partName.localeCompare(b.partName);
    sortCarsModelYearListFn = (a: any, b: any) => a.carsModelYearList[0].localeCompare(b.carsModelYearList[0]);

    ngOnInit() {
        if (this.activeTabIndex === 0) {
            this.subscription = this.sharedData.currentTabData.subscribe(data => {
                this.isAllChecked = data.otherData.allChecked;
                this.selectedLevelIds = data.otherData.selectedLevelIds;
                const queryParams = data.otherData.queryParams;
                if (data.otherData.allChecked) {
                    console.log('data.otherData', data.otherData)
                    const deselectedVehIds = data.otherData.deselectedVeh.toString();
                    this.carIds = deselectedVehIds;
                    const selectedCarInfo = {
                        carIds: deselectedVehIds,
                        levelIds: this.selectedLevelIds,
                        isSelectAll: "1",
                        ...queryParams
                    }
                    this.getCategorys(selectedCarInfo);
                } else {
                    console.log('data.otherData', data.otherData)
                    const selectedVeh = data.otherData.selectedVeh;
                    let carIds = '';
                    selectedVeh.forEach((item: any) => {
                        carIds = carIds + "," + item.carId;
                    });
                    this.carIds = carIds;
                    const selectedCarInfo = {
                        carIds: carIds,
                        levelIds: this.selectedLevelIds,
                        isSelectAll: "0",
                        ...queryParams
                    }
                    this.getCategorys(selectedCarInfo);
                    if (this.activeTabIndex === 0) {
                        const output = selectedVeh.map((item: any) =>
                            [item.carFullInfo, item.engineOilOeGuideline].filter(Boolean).map(String).join(' ')
                        );
                        this.selectedVehicles = output;
                    }
                }
            });
        }
        if (this.activeTabIndex === 1) {
            this.selectedVehicles = this.productList || [];
            const selectedCarInfo = {
                brandId: "",
                carIds: "",
                levelIds: "",
                modelClass: "",
                isSelectAll: "0",
                displacement: "",
                modelYear: "",
                modelName: "",
                maunufacturer: "",
                languageType: "zh-cn"
            }
            this.getCategorys(selectedCarInfo);
        }
    }

    ngOnDestroy() {
        if (this.activeTabIndex === 0) {
            this.subscription.unsubscribe();
        }
    }

    searchByPartNo(partNo: string) {
        this.selectedVehicles = [];
        this.filterMenu.forEach((element: any) => {
            element.checked = false;
            element.expanded = false;
            if (element.subList.length > 0) {
                element.subList.forEach((elem: any) => {
                    elem.checked = false;
                })
            }
        });
        this.partNoToFilter = partNo;
        const params = {
            page: this.pageIndex,
            pageSize: this.pageSize,
            partNo: encryptParam(partNo),
            languageType: encryptParam('zh-cn'),
        }
        this.getPartList(params)
        if (environment.production) {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const customer = JSON.parse(localStorage.getItem('customer') || '{}');
            (window as any).dataLayer.push({
                event: 'dp_eact_search_click',
                from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                event_type: 'PN',
                event_name: '',
                portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                event_content: partNo,
            });
        }
    }

    getRemarks(remark: string, categoryName: string) {
        return EcatUtils.mapRemark(remark, categoryName);
    }

    isVideoModal(remark: any) {
        const nonVideoList = ['AP1', 'AP3', 'AP4', 'AP6', '2AA', '2BB', '2CC', '1A', '1B', '2A', '2C'];
        if (nonVideoList.includes(remark)) {
            return true;
        } else {
            return false;
        }
    }

    hasVideoUrl(categoryName: string, remark: string) {
        return RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
    }

    getCategorys(selectedCarInfo: any): void {
        this.isGroupLoading = true;
        this.ecatService.getCategoryByCarList(selectedCarInfo).subscribe(result => {
            this.isGroupLoading = false;
            const { resultCode, resultData } = result;
            this.filterMenu = resultData.categoryList;
            const allCarInfo = resultData.allCarInfo;
            this.categoryListForCar = resultData.categoryListForCar;
            this.filterMenu.forEach((element: any) => {
                element.checked = false;
                element.expanded = false;
                if (element.subList.length > 0) {
                    element.subList.forEach((elem: any) => {
                        elem.checked = false;
                    })
                }
            });
            if (this.activeTabIndex === 0 && this.isAllChecked) {
                const output = allCarInfo.map((item: any) =>
                    [item.carFullInfo, item.engineOilOeGuideline].filter(Boolean).map(String).join(' ')
                );
                this.selectedVehicles = output;
                let carIdsForParts = '';
                allCarInfo.forEach((item: any) => {
                    carIdsForParts = carIdsForParts + "," + item.carId;
                });
                this.carIdsForParts = carIdsForParts;
            }

            if (this.activeTabIndex === 0 && !this.isAllChecked) {
                this.carIdsForParts = this.carIds;
            }
        })
    }

    handleIsChecked(subList: any) {
        const existButNotAll = subList.some((item: any) => item.checked === true)
            && !subList.every((item: any) => item.checked === true);
        if (existButNotAll) {
            return true
        } else {
            return false
        }
    }

    isDisabledCheckBoxAll(category1Name: string) {
        if (this.activeTabIndex === 1) return true
        if (this.categoryListForCar && this.categoryListForCar.length) {
            for (let i = 0; i < this.categoryListForCar.length; i++) {
                if (this.categoryListForCar[i].category1Name === category1Name) {
                    return true
                }
            }
        }
        return false;
    };

    isDisabledCheckBox(category2Name: string) {
        if (this.activeTabIndex === 1) return true
        if (this.categoryListForCar && this.categoryListForCar.length) {
            for (let i = 0; i < this.categoryListForCar.length; i++) {
                if (this.categoryListForCar[i].category2Name === category2Name) {
                    return true
                }
            }
        }
        return false
    };

    onPageChange(index: number) {
        this.pageIndex = index;
    }

    toggleVehicleList() {
        this.showVehicleList = !this.showVehicleList;
    }

    onGroupCheckChange(group: any) {
        if (group.checked) {
            this.selectedCategory1Name.add(group.category1Name);
        } else {
            this.selectedCategory1Name.delete(group.category1Name);
        }
        this.clearPartNoToFilter.emit();
        this.partList = [];
        if (this.activeTabIndex === 0) {
            group.subList.forEach((item: any) => {
                if (this.categoryListForCar && this.categoryListForCar.length) {
                    for (let i = 0; i < this.categoryListForCar.length; i++) {
                        if (this.categoryListForCar[i].category2Name === item.category2Name) {
                            item.checked = group.checked
                        }
                    }
                }
            });
        } else {
            group.subList.forEach((item: any) => item.checked = group.checked);
            if (group.checked) {
                if (!this.selectedVehicles.includes(group.category1Name)) {
                    this.selectedVehicles.push(group.category1Name)
                }
            } else {
                this.selectedVehicles = this.selectedVehicles.filter(item => item !== group.category1Name);
            }
        }
        setTimeout(() => {
            this.onSearch();
        }, 1000);
        if (group.checked) {
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_ecat_cat_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: this.activeTabIndex === 0 ? this.selectedVehicles : '',
                    event_name: '',
                    portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: group.category1Name,
                });
            }
        }
    }

    onSubGroupCheckChange(group: any, item: any) {
        this.clearPartNoToFilter.emit();
        this.partList = [];
        if (this.activeTabIndex === 1) {
            setTimeout(() => {
                const hasCheckedChild = group.subList.some((child: any) => child.checked === true);
                const isAllChecked = group.subList.every((child: any) => child.checked === true);
                group.checked = isAllChecked;
                if (hasCheckedChild && !this.selectedVehicles.includes(group.category1Name)) {
                    this.selectedVehicles.push(group.category1Name)
                }
                if (hasCheckedChild === false && this.selectedVehicles.includes(group.category1Name)) {
                    this.selectedVehicles = this.selectedVehicles.filter(item => item !== group.category1Name);
                }
            }, 100);
        } else {
            setTimeout(() => {
                const isAllChecked = group.subList.every((child: any) => child.checked === true);
                group.checked = isAllChecked;
            }, 100);
        }
        setTimeout(() => {
            const hasCheckedChild = group.subList.some((child: any) => child.checked === true);
            if (hasCheckedChild) {
                this.selectedCategory1Name.add(group.category1Name);
            } else {
                this.selectedCategory1Name.delete(group.category1Name);
            }
            this.onSearch();
        }, 1000);
        if (!item.checked) {
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_ecat_cat_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: this.activeTabIndex === 0 ? this.selectedVehicles : '',
                    event_name: '',
                    portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: item.category2Name,
                });
            }
        }
    }

    isIncluded() {
        const targets = ["制动系统", "蓄电池", "柴油电控系统", "火花塞"];
        const hasAny = targets.some(val => this.selectedCategory1Name.has(val));
        return hasAny;
    }

    widthConfigFunc(): string[] {
        const columnConfigs = [
            { key: 'pic', weight: 80, show: () => true },
            { key: 'typeFormular', weight: 100, show: () => this.isIncluded() },
            { key: 'partId', weight: 160, show: () => true },
            { key: 'partNoStatus', weight: 100, show: () => true },
            { key: 'partName', weight: 160, show: () => true },
            { key: 'carsModelYearList', weight: 80, show: () => this.activeTabIndex === 0 },
            { key: 'featureNameCn', weight: 100, show: () => this.selectedCategory1Name.has('雨刮') },
            { key: 'remark', weight: 100, show: () => this.activeTabIndex === 0 },
        ];

        const activeColumns = columnConfigs.filter(cfg => cfg.show());

        const totalWeight = activeColumns.reduce((sum, col) => sum + col.weight, 0);

        return activeColumns.map(col => {
            const percentage = ((col.weight / totalWeight) * 100).toFixed(2);
            return `${percentage}%`;
        });
    }

    onSearch() {
        const selectedLabels = this.filterMenu
            .flatMap((group: any) => group.subList.filter((child: any) => child.checked).map((child: any) => child.category2Name));
        if (this.partNoToFilter === '' && selectedLabels.length === 0) {
            this.partList = [];
            // this.message.create('warning', '请选择产品');
        } else {
            let category2Names = '';
            selectedLabels.forEach((item: any) => {
                category2Names = category2Names + "," + item;
            });
            let params = {};
            if (this.activeTabIndex === 0) {
                params = {
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                    category2Names: encryptParam(category2Names),
                    levelIds: encryptParam(this.selectedLevelIds),
                    carIds: encryptParam(this.carIdsForParts),
                    languageType: encryptParam('zh-cn'),
                }
            } else {
                params = {
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                    partNo: encryptParam(this.partNoToFilter),
                    category2Names: encryptParam(category2Names),
                    languageType: encryptParam('zh-cn'),
                }
            }
            this.getPartList(params)
        }
    }

    onPageSizeChange(size: number): void {
        this.pageSize = size;
        this.onSearch();
    }

    onPageIndexChange(pageIndex: number): void {
        this.pageIndex = pageIndex;
        this.onSearch();
    }

    getPartList(params: any) {
        this.isTableLoading = true;
        this.ecatService.partList(params).subscribe(result => {
            this.isTableLoading = false;
            const { resultCode, resultData } = result;
            this.pageInfo = resultData.pageInfo;
            this.partList = resultData.partList;
            this.partList.forEach(item => {
                item.partFeatureValueList && item.partFeatureValueList.forEach((feature: any) => {
                    if (feature.featureNameCn === '雨刮1长度' || feature.featureNameCn === '雨刮2长度(仅套装)' || feature.featureNameCn === '长度 1' || feature.featureNameCn === '长度 2') {
                        const regex = /(\d+(\.\d+)?)/
                        const match = feature.featureValue.match(regex)
                        if (match) {
                            const number = parseFloat(match[0])
                            const roundedNumber = number / 25.4
                            const unit = feature.featureValue.replace(match[0], '')
                            feature.featureValue = `${roundedNumber}${unit}`
                        }
                    }
                })
            })
        })
    }

    copyList() {
        const textToCopy = this.selectedVehicles.join('\n'); // 按行分隔，可自定义格式
        navigator.clipboard.writeText(textToCopy).then(() => {
            this.message.create('success', '复制成功');
        }).catch(err => {
            console.error('error:', '复制失败');
        });
    }

    onCopyPartNumber(numner: string) {
        const textToCopy = numner;
        navigator.clipboard.writeText(textToCopy).then(() => {
            this.message.create('success', '复制成功');
        }).catch(err => {
            console.error('error:', '复制失败');
        });
    }

    handleReselect() {
        if (this.activeTabIndex === 1) {
            this.clearPartNoToFilter.emit()
            this.partNoToFilter = '';
            this.selectedVehicles = [];
            this.partList = [];
            this.filterMenu.forEach((element: any) => {
                element.checked = false;
                element.expanded = false;
                if (element.subList.length > 0) {
                    element.subList.forEach((elem: any) => {
                        elem.checked = false;
                    })
                }
            });
        } else {
            this.dataEvent.emit('true');
        }
    }
    goDetail(id: number) {
        this.router.navigate([`gb/cn/parts/pc-part-detail/${id}`], {
            state: {
                isAllChecked: this.isAllChecked,
                selectedCarIds: this.carIdsForParts || this.carIds,
                selectedLevelIds: this.selectedLevelIds,
                partId: id,
                searchBySelectedCars: this.activeTabIndex === 0,
                activeTabIndex: this.activeTabIndex,
            }
        });
    }

    getImage(imageList: any) {
        if (imageList.length > 0) {
            return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + imageList[0].imageName;
        } else {
            return 'assets/official-website/no-image.png'
        }
    }

    filterFeature(partList: any) {
        let displayFeature1Name
        let displayFeature2Name
        let featureLengths = []
        // 雨刮长度
        // const rainWiperName1 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
        // const rainWiperName2 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)')
        // 长度 (英寸)
        const rainWiperName1 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1（英寸）')
        const rainWiperName2 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2（英寸）')

        if (rainWiperName1 || rainWiperName2) {
            displayFeature1Name = partList.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2' && feature.featureNameCn !== '雨刮1长度' && feature.featureNameCn !== '雨刮2长度(仅套装)')
            featureLengths = displayFeature1Name
        } else {
            // 长度 (mm)
            // const rainWiperName3 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1')
            // const rainWiperName4 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2')
            // 雨刮长度
            const rainWiperName3 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
            const rainWiperName4 = partList.partFeatureValueList && partList.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
            if (rainWiperName3 || rainWiperName4) {
                // 长度 (英寸)
                displayFeature2Name = partList.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2')
                featureLengths = displayFeature2Name
            } else {
                featureLengths = partList.partFeatureValueList
            }
        }
        return featureLengths
    };

    editFeatureNameCn(featureNameCn: any, partNo: any): string {
        if (!featureNameCn) {
            return ''; // Return empty string instead of undefined
        }

        const item = this.partList.find(item => item.partNo === partNo); // `.find` is cleaner than `.filter()[0]`
        if (!item) {
            return ''; // Handle case where item is not found
        }

        const isAllSize1 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮1长度')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)');
        const isAllSize2 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 2');
        const isAllSize3 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1（英寸）')
            && item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 2（英寸）');
        const isOnlySize1 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '雨刮1长度');
        const isOnlySize2 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1');
        const isOnlySize3 = item.partFeatureValueList.some((feature: any) => feature.featureNameCn === '长度 1（英寸）');

        // 英寸存在
        if (isAllSize3) {
            if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                return '主驾尺寸(英寸)';
            } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                return '副驾尺寸(英寸)';
            }
        }
        // 雨刮长度存在
        else if (isAllSize1) {
            if (isOnlySize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // mm存在
        else if (isAllSize2) {
            if (isOnlySize1 || isOnlySize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // 仅存在英寸
        else if (isOnlySize3) {
            return '尺寸(英寸)';
        }
        // 仅存在雨刮长度
        else if (isOnlySize1) {
            if (!isAllSize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        // 仅存在mm
        else if (isOnlySize2) {
            if (!isAllSize1 && !isAllSize3) {
                return '尺寸(英寸)';
            } else {
                if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
                    return '主驾尺寸(英寸)';
                } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
                    return '副驾尺寸(英寸)';
                }
            }
        }
        return ''; // Default return if none of the conditions match
    };

    openVideoModal(categoryName: string, remark: string): void {
        let videoUrl = RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
        this.modal.create({
            nzTitle: '视频播放',
            nzContent: VideoModalComponent,
            nzComponentParams: {
                videoUrl: videoUrl
            },
            nzFooter: null,
            nzWidth: 800
        });
    }
}